export default __webpack_public_path__ + "static/media/01.d4d71333.jpg";